import { Group, Pagination } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import * as C from '../../../ui/common/CommonStyles';
import { useCustomSearch } from '../../../../shared/hook/useCustomSearch';
import CustomSearch from '../../../ui/search/customSearch';
import CompanyInfoModal from './components/CompanyInfoModal';
import PermissionModal from './components/permissionModal';
import ProdoqMemberTable from './components/prodoqMemberTable';
import RoleRegModal from './components/roleRegModal';
import useGetProdoqCompanies from './hooks/useGetProdoqCompanies';
import { prodoqPermissionStore } from '../../../../shared/store/prodoqPermission.store';

import type { IProdoqCompanyResponse } from '../../../../shared/types/prodoq';

const options = [{ value: 'companyName', label: '회사명' }];

export default function ProdoqRole() {
  const resetPermissionData = prodoqPermissionStore((state) => state.resetPermissionData);
  const [openedCompanyInfoModal, { open: openCompanyInfoModal, close: closeCompanyInfoModal }] = useDisclosure(false);
  const [openedRoleRegModal, { open: openRoleRegModal, close: closeRoleRegModal }] = useDisclosure(false);
  const [openedPermissionModal, { open: openPermissionModal, close: closePermissionModal }] = useDisclosure(false);
  const [selectedCompany, setSelectedCompany] = useState<IProdoqCompanyResponse | null>(null);
  const [searchParams, setSearchParams] = useSearchParams('');
  const searchWord = searchParams.get('searchWord') || '';
  const searchType = searchParams.get('searchType') || 'companyName';
  const page = searchParams.get('pg') || '1';
  const size = searchParams.get('pgSize') || '10';
  const { inputRef, handleSearch, resetWord, handleSearchType, resetSearchInput } = useCustomSearch({
    initType: 'companyName',
    searchKey: 'searchType',
    searchWordKey: 'searchWord',
    pageKey: 'pg',
  });

  const { data: prodoqCompanies } = useGetProdoqCompanies({
    pg: Number(page),
    pgSize: Number(size),
    searchWord: searchWord,
    searchType,
  });

  const onClickOpenCompanyInfo = (company: IProdoqCompanyResponse) => {
    setSelectedCompany(company);
    openCompanyInfoModal();
  };

  const onClickCloseCompanyInfo = () => {
    setSelectedCompany(null);
    closeCompanyInfoModal();
  };

  const onClickOpenRoleManage = (company: IProdoqCompanyResponse) => {
    setSelectedCompany(company);
    openRoleRegModal();
  };

  const onClickCloseRoleManage = () => {
    setSelectedCompany(null);
    closeRoleRegModal();
  };

  const onClickOpenPermissionManage = (company: IProdoqCompanyResponse) => {
    setSelectedCompany(company);
    openPermissionModal();
  };

  const onClickClosePermissionManage = () => {
    setSelectedCompany(null);
    closePermissionModal();
    resetPermissionData();
  };

  return (
    <div>
      <C.TitleBox>
        <div className="title">회사계정 관리</div>
      </C.TitleBox>
      <C.ListBox>
        <C.Toolbar>
          <CustomSearch
            resetSearch={resetWord}
            resetSearchInput={resetSearchInput}
            searchType={searchType}
            setSearchType={handleSearchType}
            inputRef={inputRef}
            handleSearch={handleSearch}
            searchOptions={options}
          />
        </C.Toolbar>
        <ProdoqMemberTable
          data={prodoqCompanies?.list || []}
          openCompanyInfoModal={onClickOpenCompanyInfo}
          openRoleRegModal={onClickOpenRoleManage}
          openPermissionModal={onClickOpenPermissionManage}
        />
        <Group justify="center" mt="md">
          <Pagination
            total={Math.ceil((prodoqCompanies?.totalCount ?? 0) / Number(size))}
            value={Number(page)}
            onChange={(page) => setSearchParams({ ...Object.fromEntries(searchParams.entries()), pg: String(page) })}
          />
        </Group>
        {openedCompanyInfoModal && (
          <CompanyInfoModal opened={openedCompanyInfoModal} onClose={onClickCloseCompanyInfo} selectedCompany={selectedCompany} />
        )}
        {openedRoleRegModal && (
          <RoleRegModal opened={openedRoleRegModal} onClose={onClickCloseRoleManage} selectedCompany={selectedCompany} />
        )}
        {openedPermissionModal && (
          <PermissionModal
            opened={openedPermissionModal}
            onClose={onClickClosePermissionManage}
            selectedCompany={selectedCompany}
          />
        )}
      </C.ListBox>
    </div>
  );
}
